import React from "react";

export type ToastData = {
    title: string;
    message: string;
    type: "Success" | "Error";
    duration: number;
    positions: {
        top?: number;
        bottom?: number;
        left?: number;
        right?: number;
    };
};

export type ToastDataWithId = ToastData & { id: string };

export type ToastContextType = {
    add: (toast: ToastData) => void;
    remove: (toastId: string) => void;
};

export const ToastContext = React.createContext<ToastContextType | undefined>(undefined);
